// extracted by mini-css-extract-plugin
module.exports = {"product-card-container":"StoryblokProductCard_product-card-container__TNtl2"};